import { interpolateRgb } from 'd3-interpolate'
import zip from 'lodash-es/zip'

export function createColorBreaks(breaks: number[], colors: string[]): [number, string][] {
  if (colors.length < 2) {
    throw new Error('At least 2 colors are required')
  }

  return breaks.map((break_value, index) => {
    // Simple linear interpolation between colors based on position
    const colorPosition = index / (breaks.length - 1)
    const colorIndex = colorPosition * (colors.length - 1)
    const lowerIndex = Math.floor(colorIndex)
    const upperIndex = Math.min(lowerIndex + 1, colors.length - 1)
    const fraction = colorIndex - lowerIndex

    const interpolatedColor = interpolateRgb(colors[lowerIndex]!, colors[upperIndex]!)(fraction)

    return [break_value, interpolatedColor.toString()] as [number, string]
  })
}

function lerp(from: number, to: number, stop: number): number {
  return from + (to - from) * stop
}

function inverseLerp(a: number, b: number, value: number): number {
  return (value - a) / (b - a)
}

export function interpolateRGB(
  domainFrom: number,
  domainTo: number,
  from: readonly [number, number, number],
  to: readonly [number, number, number]
): (stop: number) => [number, number, number] {
  return (stop: number) =>
    zip(from, to).map(([from, to]) =>
      lerp(from!, to!, inverseLerp(domainFrom, domainTo, stop))
    ) as [number, number, number]
}
